import React, { useState, useEffect } from "react";
import Header from "../../components/template/website/Header";
import Footer from "../../components/template/estimate/Footer";
import { useForm } from "react-hook-form";
import {
  sendOTP,
  authenticateOTP,
  getCustomerInfo,
  checkForDuplicateEmail,
  registerCustomer,
  createLeadOnLogin,
} from "../../adapters/auth/Login";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { thunkLoginUser } from "../../redux/reducers/user_info/userInfoReducer";
import config from "../../config/config";
import { BOXIGO_WEBSITE_LINKS } from "../../constants/navigation_links";
export default function Login() {
  const { register, errors, handleSubmit, getValues } = useForm();
  const history = useHistory();
  const dispatch = useDispatch();

  const isLoggedIn = useSelector((state) => state.userInfo.loggedIn);

  const [isOTPsent, setIsOTPsent] = useState(false);
  // const [isOTP_resent, setIsOTP_resent] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [timerCount, setTimerCount] = useState(30);
  const [timerStatus, setTimerStatus] = useState(false);

  // const [isSubmitting, setIsSubmitting] = useState(false);
  // const [error, setError] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [utmUrl, setUtmUrl] = useState(null);

  const onSubmit = async (data) => {
    // console.log(data);
    //1. Send OTP.
    //2. AuthOTP and phone and login.
    //3. if new user insert and login.
    if (isOTPsent === false) {
      handleSendOTP(data);
    } else if (isOTPsent === true && isNewUser === false) {
      handleLoginAuth(data);
    } else if (isNewUser === true) {
      handleNewUserLogin(data);
    }
  };

  const handleLoginAuth = async (data) => {
    //clientTimezone
    const body = {
      emailId: null,
      mobile: data["phone"],
      otp: data["otp"],
      password: null,
      loginType: "mobile",
    };
    setStatusMessage("Verifying OTP, Please wait...");
    try {
      const response = await authenticateOTP(body);
      // console.log(response);

      if (response.status === 200) {
        try {
          const customerData = await getCustomerInfo(data["phone"]);
          // console.log(customerData);
          await createLeadOnLogin(customerData["data"]["data"][0], "existing");
          if (
            customerData["data"]["meta"]["code"] === 200 &&
            customerData["data"]["meta"]["status"] === "OK"
          ) {
            const data = customerData["data"]["data"][0];
            setIsOTPsent(true);
            setStatusMessage("OTP is verified, Logging in...");
            const userInfoSession = {
              loggedIn: true,
              email: data["email"],
              customerName: data["first_name"],
              isEmailVerified: data["is_email_verified"],
              isPhoneVerified: data["is_phone_verified"],
              userId: data["user_id"],
              phone: data["phone"],
              alternatePhone: data["alternate_phone"],
            };

            sessionStorage.setItem(
              "userSessionData",
              JSON.stringify(userInfoSession)
            );

            const reduxPayload = {
              ...userInfoSession,
              history,
            };
            dispatch(thunkLoginUser(reduxPayload));
          } else {
            setStatusMessage("An Error occurred, Please try again later.");
          }
        } catch (error) {
          // console.log(error.response.data);
          if (
            error.response.data.meta.code === 404 &&
            error.response.data.meta.status === "failed"
          ) {
            //create an customer
            setIsNewUser(true);
            setStatusMessage("");
            return;
          } else {
            setStatusMessage("An Error occurred, Please try again later.");
          }
        }
      } else {
        setStatusMessage("An Error occurred, Please try again later.");
      }
    } catch (e) {
      console.error("error occurred", e);
      setStatusMessage("An Error occurred, Please try again later.");
    }
  };

  const handleSendOTP = async (data) => {
    setStatusMessage("Sending OTP..");
    try {
      const response = await sendOTP(data["phone"]);
      if (response.status === 200) {
        setIsOTPsent(true);
        setTimerStatus(true);
        setStatusMessage("OTP is sent to your number.");
      } else {
        setStatusMessage("An Error occurred, Please try again later.");
      }
    } catch (e) {
      console.error("error occurred", e);
      setStatusMessage("An Error occurred, Please try again later.");
    }
  };
  const resendOTP = async () => {
    const phone = getValues("phone");
    setStatusMessage("Sending OTP..");
    try {
      const response = await sendOTP(phone);
      if (response.status === 200) {
        // setIsOTP_resent(true);
        setTimerStatus(true);
        setStatusMessage("OTP is sent to your number.");
      } else {
        setStatusMessage("An Error occurred, Please try again later.");
      }
    } catch (e) {
      console.error("error occurred", e);
      setStatusMessage("An Error occurred, Please try again later.");
    }
  };

  const handleNewUserLogin = async (data) => {
    setStatusMessage("Processing...");
    try {
      let response = await checkForDuplicateEmail(data["email"]);
      if (response.status === 200) {
        // setIsOTP_resent(true);
        setTimerStatus(true);
        setStatusMessage("Email Already exists.");
      }
    } catch (error) {
      if (error.response.data) {
        if (error.response.data.meta.code === 404) {
          let body = {
            phone: data["phone"],
            first_name: data["fullName"],
            last_name: "",
            email: data["email"],
          };
          try {
            let response = await registerCustomer(body);
            if (
              response["data"]["meta"]["code"] === "200" &&
              response["data"]["meta"]["status"] === "OK"
            ) {
              let payloadData = response["data"]["data"];
              // payloadData["urlpath"] = window.location.href.trim();
              payloadData["urlpath"] = utmUrl;
              // alert(utmUrl)
              await createLeadOnLogin(payloadData, "new");
              setStatusMessage("Registered successfully, Logging in...");
              const data = response["data"]["data"];
              setIsOTPsent(true);
              setStatusMessage("OTP is verified, Logging in...");
              const userInfoSession = {
                loggedIn: true,
                email: data["email"],
                customerName: data["first_name"],
                isEmailVerified: "0",
                isPhoneVerified: "0",
                userId: data["user_id"],
                phone: data["phone"],
              };

              sessionStorage.setItem(
                "userSessionData",
                JSON.stringify(userInfoSession)
              );

              const reduxPayload = {
                ...userInfoSession,
                history,
              };
              dispatch(thunkLoginUser(reduxPayload));
            } else {
              setStatusMessage("An Error occurred, Please try again later.");
            }
          } catch (error) {
            console.log(error);
            setStatusMessage("An Error occurred, Please try again later.");
          }
        }
      } else {
        setStatusMessage("An Error occurred, Please try again later.");
      }
    }
  };

  const utmUrlhandler = (url) => {
    const urlPathIndex = url.indexOf('urlpath=');
  if (urlPathIndex !== -1) {
    const substring = url.slice(urlPathIndex + 'urlpath='.length); 
    setUtmUrl(substring)
    // alert(substring)
  } else {
    setUtmUrl(url)
    // alert(url) 
  }
  };

  useEffect(() => {
    utmUrlhandler(window.location.href.trim());
  }, []);

  useEffect(() => {
    if (isLoggedIn === true) {
      history.push("/dashboard");
    }
  }, [isLoggedIn, history]);

  useEffect(() => {
    let timerInterval = null;
    if (timerStatus === true) {
      timerInterval = setInterval(() => {
        setTimerCount((prevousCount) => prevousCount - 1);
      }, 1000);
    } else {
      setTimerCount(30);
      clearInterval(timerInterval);
    }
    return () => {
      setTimerCount(30);
      clearInterval(timerInterval);
    };
  }, [timerStatus]);

  useEffect(() => {
    if (timerCount === 0) {
      setTimerStatus(false);
      setTimerCount(30);
    }
  }, [timerCount]);

  useEffect(() => {
    if (isLoggedIn === false) {
      history.push("/login");
    }
  }, [isLoggedIn, history]);

  const JSX = (
    <>
      <Header />
      <main className="container-fluid login ">
        <section className="login-section">
          <div className="login-container container">
            <div className="row align-items-center">
              <div className="col-sm-12 col-md-6">
                <div className="content content-left">
                  <h1>
                    Vendor <br /> Login
                  </h1>
                  <a
                    href={config.vendorPortal}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn"
                  >
                    {" "}
                    Login{" "}
                  </a>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                <div className={`login-form ${isNewUser && "register-form"}`}>
                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    id="loginForm"
                    autoComplete="off"
                  >
                    <h1 className="mb-4">
                      {" "}
                      Customer <br /> Login{" "}
                    </h1>
                    <div className={`form-group ${!isOTPsent && "full-grid"}`}>
                      <input
                        type="text"
                        className={`form-control ${errors.phone && "error"}`}
                        name="phone"
                        id="phone"
                        defaultValue=""
                        readOnly={isOTPsent === true ? true : false}
                        ref={register({
                          required: true,
                          validate: {
                            numberOnly: (value) => {
                              return /^[0-9]*$/i.test(value);
                            },
                            phoneLength: (value) => {
                              return value.length === 10 ? true : false;
                            },
                          },
                        })}
                        placeholder="Mobile No"
                      />
                      {isOTPsent && (
                        <input
                          type="button"
                          className="btn"
                          // id="changeNumber"
                          onClick={() => {
                            setIsOTPsent(false);
                            setIsNewUser(false);
                            setStatusMessage("");
                          }}
                          value="Change"
                        />
                      )}

                      <span className="error-text phone-error">
                        {errors.phone &&
                          errors.phone.type === "required" &&
                          "Required."}
                        {errors.phone &&
                          errors.phone.type === "phoneLength" &&
                          "Please enter 10 digit phone."}
                        {errors.phone &&
                          errors.phone.type === "numberOnly" &&
                          "Please enter only numbers"}
                      </span>
                    </div>
                    {isOTPsent === true && isNewUser === false && (
                      <div className="form-group otp-container">
                        <input
                          type="text"
                          className={`form-control ${errors.otp && "error"}`}
                          name="otp"
                          ref={register({
                            required: true,
                            validate: {
                              numberOnly: (value) => {
                                return /^[0-9]*$/i.test(value);
                              },
                              validOTPLength: (value) => {
                                return value.length === 4 ? true : false;
                              },
                            },
                          })}
                          id="otp"
                          placeholder="Enter OTP"
                        />
                        <button
                          type="button"
                          id="resendOTP"
                          onClick={() => resendOTP()}
                          className={`btn timer text-center`}
                          disabled={timerStatus === true ? true : false}
                        >
                          {timerStatus === false &&
                            isOTPsent === true &&
                            "Resend OTP"}
                          {timerStatus === true && "0:" + timerCount}
                        </button>
                        <span className="error-text otp-error">
                          {errors.otp &&
                            errors.otp.type === "required" &&
                            "Required."}
                          {errors.otp &&
                            errors.otp.type === "validOTPLength" &&
                            "Please enter 4 digit OTP."}
                          {errors.otp &&
                            errors.otp.type === "numberOnly" &&
                            "Please enter only numbers"}
                        </span>
                      </div>
                    )}

                    {isNewUser === true && (
                      <div className="register-container">
                        <div className="form-group full-grid">
                          <input
                            type="text"
                            className={`form-control ${
                              errors.fullName && "error"
                            }`}
                            id="fullName"
                            name="fullName"
                            ref={register({
                              required: true,
                              validate: {
                                validName: (value) =>
                                  /^[a-z" ".]*$/i.test(value),
                                maxLength: (value) =>
                                  value.length > 30 ? false : true,
                              },
                            })}
                            placeholder="Your Name"
                          />
                          <span className="error-text full_name-error">
                            {errors.fullName &&
                              errors.fullName.type === "required" &&
                              "Required."}
                            {errors.fullName &&
                              errors.fullName.type === "validName" &&
                              "Please enter only alphabets."}
                            {errors.fullName &&
                              errors.fullName.type === "maxLength" &&
                              "Maximum character allowed is 30."}
                          </span>
                        </div>
                        <div className="form-group full-grid">
                          <input
                            type="text"
                            className={`form-control ${
                              errors.email && "error"
                            }`}
                            id="email"
                            name="email"
                            ref={register({
                              required: true,
                              email: true,
                              validate: {
                                validEmail: (value) => {
                                  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                    value
                                  );
                                },
                                maxLength: (value) =>
                                  value.length > 40 ? false : true,
                              },
                            })}
                            placeholder="Email Id"
                          />
                          <span className="error-text email-error">
                            {errors.email &&
                              errors.email.type === "required" &&
                              "Required."}
                            {errors.email &&
                              errors.email.type === "validEmail" &&
                              "Please enter a valid email."}
                            {errors.email &&
                              errors.email.type === "maxLength" &&
                              "Maximum character allowed is 40."}
                          </span>
                          <div className="terms-and-conditions">
                            By signing up I accept to the{" "}
                            <a
                              href={
                                BOXIGO_WEBSITE_LINKS.customer_terms_and_conditions_page
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              terms &amp; conditions{" "}
                            </a>{" "}
                            and
                            <a
                              href={
                                BOXIGO_WEBSITE_LINKS.customer_privacy_policy_page
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              privacy policy{" "}
                            </a>{" "}
                            of Boxigo
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="login-btn-container">
                      <div>
                        {isOTPsent === false && isNewUser === false && (
                          <button className="btn" id="sendOTP" type="submit">
                            {" "}
                            Send OTP{" "}
                          </button>
                        )}
                        {isOTPsent === true && isNewUser === false && (
                          <button
                            type="submit"
                            className="btn mt-0 login-btn"
                            id="confirmOTP"
                          >
                            Login
                          </button>
                        )}
                      </div>
                    </div>
                    {isNewUser === true && (
                      <div className="register-submit-container">
                        <input
                          type="submit"
                          className="btn mt-0"
                          id="registerCustomer"
                          value="Register"
                        />
                        <div className="sub-info">
                          <p className="text-center mt-3">
                            You will not receive any spam calls or third party
                            calls{" "}
                          </p>
                        </div>
                      </div>
                    )}
                    {statusMessage !== "" && (
                      <div id="msg" className="d-block">
                        {" "}
                        {statusMessage}{" "}
                      </div>
                    )}
                    <div class="mobile-storage-link">
                      <a
                        className="link active-link text-capitalize"
                        style={{ textDecoration: "underline" }}
                        href="https://books.boxigo.in/portal/boxigo/login"
                      >
                        <b>Click Here </b>
                      </a>
                      for Monthly <b>Storage Payment </b>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="container storage-link">
          <div className="row mb-4">
            <div className="col-sm-6 col-md-6"></div>
            <div className="col-sm-6 col-md-6">
              <a
                className="link active-link text-capitalize"
                style={{ textDecoration: "underline" }}
                href="https://books.boxigo.in/portal/boxigo/login"
              >
                <b>Click Here </b>
              </a>
              for Monthly <b>Storage Payment </b>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
  return JSX;
}
